import React, { useState, useEffect, useContext, useRef } from "react";
import { APIURL, APIPath } from "../CommonMethods/Fetch";
import ReactAudioPlayer from "react-audio-player";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { postRecord } from "../CommonMethods/Save";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../CommonMethods/Authentication";
import ReactPannellum, { getConfig } from "react-pannellum";
import GoogleMapReact from "google-map-react";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CancelIcon from "@material-ui/icons/Cancel";
import Snackbar from "@material-ui/core/Snackbar";
import Skeleton from "@material-ui/lab/Skeleton";
import MuiAlert from "@material-ui/lab/Alert";
import mission_bg from "../images/mission-img2.jpg";
import { Button } from "@material-ui/core";
import banner1 from "../images/banner1.jpg";
import banner2 from "../images/banner2.jpg";
import banner3 from "../images/banner3.jpg";
import realpics3 from "../images/realpics3.jpg";
import playbtn from "../images/playbtn-parallax.png";
import BetterWorld from "../images/Better_World_full_mix.mp3";
import zoomIcon from "../images/zoomicon.png";
import about1 from "../images/about1.jpg";
import videobg from "../images/videobg.jpg";
import playicon from "../images/playicon.png";
import profileImg from "../images/profilephoto.jpg";
import vtcLogoTop from "../images/VTC-logo_top.png";
import vtclogo from "../images/VTC-logo.png";
import footericon1 from "../images/footer-icon1.png";
import footericon2 from "../images/footer-icon2.png";
import Contactbg from "../images/contact_bg.jpg";
import Parllel from "../images/pause-btn-parallax.png";
import photo from "../images/photos.jpg";
import svg1 from "../images/43.svg";
import zoom from "../images/zoom1.png";
import ReactImageZoom from "react-image-zoom";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TwitterShareButton,
} from "react-share";
const APIGetUserData = APIURL() + "user-details";
const APIGetTourDetails = APIURL() + "tour-details";
const APIGetSiteSetting = APIURL() + "sitesetting";
const APIGetSocialIconLink = APIURL() + "getsocialicons";
const APIGetTourInfo = APIURL() + "get-Tourinfo";
const APIGetMortgageCalculator = APIURL() + "get-Mortgage-Calculator";
const APIGetContactAgent = APIURL() + "get-Contact-Agent";
const APIGetScheduleAppointment = APIURL() + "get-scheduleMail";
const APIGetFloorList = APIURL() + "edit-floor-Plans";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  lightbox: {
    position: "absolute",
    //textAlign: "center",
    "& h2::after": {
      // backgroundImage: "url(" + ftr_head + ")",
      content: '""',
      height: "4px",
      width: "50px",
      position: "absolute",
      textAlign: "center",
      right: "0",
      left: "0",
      bottom: "-20px",
      margin: "0 auto",
    },
  },
  have_need_sec_left_img: {
    position: "relative",
    textAlign: "center",
    margin: "0 auto",
    // minHeight: "100px",
    "& ::after": {
      content: '""',
      position: "absolute",
      right: 0,
      left: 0,
      margin: "0 auto",
      textAlign: "center",
      //background: "url(" + pic_bg + ")",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      width: "170px",
      height: "115px",
      zIndex: "-1",
      top: "-97px",
    },
  },
  our_partners_head: {
    position: "relative",
    textAlign: "center",
    "& h2::after": {
      //backgroundImage: "url(" + ftr_head + ")",
      content: '""',
      height: "4px",
      width: "50px",
      position: "absolute",
      textAlign: "center",
      right: "0",
      left: "0",
      bottom: "-20px",
      margin: "0 auto",
    },
  },
}));
const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default function Themetemplate(props) {
  const features = useRef(null);
  const photos = useRef(null);
  const videos = useRef(null);
  const panorama = useRef(null);
  const location = useRef(null);
  const presentedBy = useRef(null);
  const floorPlans = useRef(null);
  const propertyRef = useRef(null);
  const contact = useRef(null);
  const threeD = useRef(null);
  const documents = props.documents;
  const AgnetID = props.AgentId;
  const ThemeId = props.ThemeId;
  const threeDs = props.threeDs;
  const tourid = props.tourid;
  const agentProfile = props.agentProfile;
  const amenities = props.amenities;
  const music = props.music;
  const tourData = props.tourData;
  const statename = props.statename;
  const category = props.category;
  const panoSetting = props.panoSetting;
  const slideSetting = props.slideSetting;
  const mls = props.mls;
  const strict = props.strict;
  const coAgentData = props.coAgentData;

  // ===============important=============/
  // const AgnetID = props.match.params.id;
  // const ThemeId = props.match.params.themeid;
  // ===============important=============/
  // const AgnetID = 7686;
  // const ThemeId = 4388002;
  const size = useWindowSize();
  const [mobileClass, setMobileClass] = useState("small-screen");
  const [show, setShow] = useState(false);
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional smooth scrolling behavior
    });
  };
  useEffect(() => {
    if (size.width <= 768) {
      console.log("Adding mobileClass");
      setMobileClass("small-screen");
      setShow(false);
    } else {
      console.log("removing mobileClass");
      setMobileClass("");
      setShow(true);
    }
  }, [size]);
  useEffect(() => {
    setShow(false);
  }, []);

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 500,
      color: "#fff",
    },
  }));
  const classes = useStyles();
  const { dispatch } = useContext(AuthContext);
  const context = useContext(AuthContext);

  let history = useHistory();
  const [sync, setSync] = useState(true);
  const [openError, setOpenError] = useState(false);
  // const [statename, setstatename] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [currentUser, setCurrentUser] = useState({});
  const [data, setData] = useState({});
  const [iconData, setIconData] = useState({});
  const [tourInfo, setTourInfo] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [videoData, setVideoData] = useState([]);
  const [tourDetailsData, setTourDetailsData] = useState({});
  const [tourStatus, setTourStatus] = useState("");
  const [largeWidth, setLargeWidth] = React.useState("lg");
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [openAgentinfo, setopenAgentInfo] = useState(false);
  const [openContactinfo, setopenContactInfo] = useState(false);
  const [openAppointment, setopenAppointment] = useState(false);
  const [openMortagage, setOpenMortgage] = useState(false);
  const [amenityData, setAmenityData] = useState({});
  const [openAmenties, setOpenAmenties] = useState(false);
  const [openPropertyInformation, setOpenProertyInfromation] = useState(false);
  const [panoromaData, setPanromaData] = useState([]);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [openWalkScore, setOpenWalkScore] = useState(false);
  const [openPanoromaModal, setOpenPanoromaModal] = useState(false);
  const [openHouseModal, setOpenHouseModal] = useState(false);
  const [panoUrl, setPanoUrl] = useState("");
  const [facebookLink, setFacebookLink] = useState("");
  const [TwitterLink, setTwitterLink] = useState("");
  const [youTubeLink, setYoutubeLink] = useState("");
  const [sendMail, setSendMail] = useState({});
  const [open, setOpen] = useState(false);
  const [floorPlanData, setFloorPlansData] = useState({});
  const [tourDetails, setTourDetails] = useState({});
  const scrollToElement = (e, elementRef) => {
    e.preventDefault();
    if (elementRef.current) {
      elementRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  // console.log("tourPrice",typeof(tourDetailsData.Price));

  // const [agentProfile, setAgentProfile] = useState("");
  // const [amenities, setAmenities] = useState({});
  // const [music, setMusic] = useState("");
  // const [tourData, setTourData] = useState({});
  // const [category, setCategory] = useState("");
  // const [panoSetting, setPanoSetting] = useState({});
  // const [slideSetting, setSlideSetting] = useState({});
  useEffect(() => {
    const objusr = {
      authenticate_key: "abcd123XYZ",
      agent_id: AgnetID,
    };
    postRecord(APIGetUserData, objusr).then((res) => {
      if (res.data[0].response.status === "success") {
        setCurrentUser(res.data[0].response.data.agent_profile);
        // setAgentProfile(res.data[0].response.data.agent_profile.profile_img);
      }
    });
  }, [AgnetID]);

  useEffect(() => {
    window.scroll(0, 0);
    const obj = { authenticate_key: "abcd123XYZ" };
    postRecord(APIGetSiteSetting, obj).then((res) => {
      // console.log(res);
      if (res.data[0].response.status === "success") {
        setData(res.data[0].response.data);
      }
    });
  }, []);
  const [map, setMap] = useState(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!strict) viewMap();
  }, [tourData.latitude, tourData.longitude, strict]);

  const viewMap = () => {
    const latitude = tourData.latitude;
    const longitude = tourData.longitude;

    if (latitude && longitude) {
      const mapOptions = {
        center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
        zoom: 17,
      };
      const newMap = new window.google.maps.Map(mapRef.current, mapOptions);
      setMap(newMap);
      setMarker(newMap, parseFloat(latitude), parseFloat(longitude));
    } else {
      const defaultMapOptions = {
        center: { lat: 35.119345, lng: -89.938934 },
        zoom: 17,
      };
      const newMap = new window.google.maps.Map(
        mapRef.current,
        defaultMapOptions,
      );
      setMap(newMap);
      setMarker(newMap);
    }
  };

  const setMarker = (map, lat = null, long = null) => {
    if (lat && long) {
      const location = { lat: lat, lng: long };
      new window.google.maps.Marker({
        position: location,
        map: map,
      });
      map.setCenter(location);
    } else {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: getAddress() }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          const location = results[0].geometry.location;
          new window.google.maps.Marker({
            position: location,
            map: map,
          });
          map.setCenter(location);
        }
      });
    }
  };

  const getAddress = () => {
    const { address, city, state, zipcode, country } = tourData;
    return `${address}, ${city}, ${state}, ${zipcode}, ${country}`;
  };
  useEffect(() => {
    const objusr = {
      authenticate_key: "abcd123XYZ",
      agentId: AgnetID,
      tourid: tourid,
    };
    postRecord(APIGetTourDetails, objusr).then((res) => {
      console.log(res.data[0].response);
      if (res.data[0].response.status === "success") {
        setTourDetails(res.data[0].response);
      }
    });
  }, [AgnetID]);

  useEffect(() => {
    const obj = {
      authenticate_key: "abcd123XYZ",
      agent_id: AgnetID,
      tourId: tourid,
    };
    if (AgnetID) {
      postRecord(APIGetSocialIconLink, obj).then((res) => {
        // console.log(res);
        if (res.data[0].response.status === "success") {
          setIconData(res.data[0].response);
          setFacebookLink(res.data[0].response.data.facebooklink);
          setTwitterLink(res.data[0].response.data.twitterlink);
          setYoutubeLink(res.data[0].response.data.ytLink);
        }
      });
    }
  }, [AgnetID]);
  useEffect(() => {
    const objusr = {
      authenticate_key: "abcd123XYZ",
      agentId: AgnetID,
      tourid: tourid,
    };
    postRecord(APIGetTourInfo, objusr).then((res) => {
      if (res.data[0].response.status === "success") {
        setImageData(res.data[0].response.dataDetails.dataProvider);
        const fullUrl = window.location.href;
        let filteredVideos;

        if (fullUrl.includes("/mls/")) {
          filteredVideos =
            res.data[0].response.dataDetails.dataProvider2.filter(
              (video) => video.enable_on_mls === 1,
            );
        } else {
          filteredVideos =
            res.data[0].response.dataDetails.dataProvider2.filter(
              (video) => video.enable_on_mls === 0,
            );
        }
        setVideoData(filteredVideos);
        // setVideoData(res.data[0].response.dataDetails.dataProvider2);
        setTourDetailsData(res.data[0].response.dataDetails.tourdetails);
        setTourStatus(res.data[0].response.dataDetails.tourdetails.category);
        setPanromaData(res.data[0].response.dataDetails.dataProvider3);
        setFloorPlansData(res.data[0].response.dataDetails.dataProvider4);
      }
    });
  }, [AgnetID, ThemeId]);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
    setOpenError(false);
  };
  console.log("anil tour status", tourStatus);

  // useEffect(() => {
  //     if (music) {
  //         console.log(music);
  //         var source = music;
  //         var audio = new Audio();
  //         audio.addEventListener("load", function () {
  //             audio.play();
  //         }, true);
  //         audio.src = source;
  //         audio.autoplay = true;
  //         document.getElementById("button").src = Parllel
  //         document.querySelectorAll('.bar-c .bar').forEach(n => n.classList.remove('noAnim'));
  //     }
  // }, [music]);

  function togglePlay() {
    var track = document.getElementById("track1");
    if (track.paused) {
      track.muted = false;
      track.load();
      track.play();
      document.getElementById("button").src = Parllel;
      document
        .querySelectorAll(".bar-c .bar")
        .forEach((n) => n.classList.remove("noAnim"));
    } else {
      track.load();
      track.pause();
      document.getElementById("button").src = playbtn;
      document
        .querySelectorAll(".bar-c .bar")
        .forEach((n) => n.classList.add("noAnim"));
    }
  }

  const amenityHandleChange = (event) => {
    const { name, value } = event.target;
    setAmenityData({ ...amenityData, [name]: value });
  };

  const initialMorgageData = {
    length: "",
    rate: "",
    price: "",
    downpayment: "",
  };
  const [mortgageData, setMortgageData] = useState(initialMorgageData);
  const [mortgageResult, setMortgageResult] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const inputHandleChange = (event) => {
    const { name, value } = event.target;
    setMortgageData({ ...mortgageData, [name]: value });
  };
  const validateForm = () => {
    let newErrors = {};

    if (!mortgageData.length) {
      newErrors.length = "Mortgage length is required.";
    } else if (!/^\d+$/.test(mortgageData.length)) {
      newErrors.length = "Mortgage length must be a valid number.";
    }

    if (!mortgageData.rate) {
      newErrors.rate = "Interest rate is required.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(mortgageData.rate)) {
      newErrors.rate =
        "Enter a valid interest rate (e.g., 5.5, 3.25). No '%' symbol.";
    }

    if (!mortgageData.price) {
      newErrors.price = "House price is required.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(mortgageData.price)) {
      newErrors.price = "Enter a valid price (e.g., 250000 or 250000.50).";
    } else if (parseFloat(mortgageData.price) <= 0) {
      newErrors.price = "House price must be a positive number.";
    }

    if (!mortgageData.downpayment) {
      newErrors.downpayment = "Down payment is required.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(mortgageData.downpayment)) {
      newErrors.downpayment =
        "Enter a valid down payment (e.g., 50000 or 50000.75).";
    } else if (parseFloat(mortgageData.downpayment) <= 0) {
      newErrors.downpayment = "Down payment must be a positive number.";
    } else if (
      parseFloat(mortgageData.downpayment) >= parseFloat(mortgageData.price)
    ) {
      newErrors.downpayment = "Down payment must be less than the house price.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const CalculateMortgage = () => {
    setLoading(true); // Start loading
    mortgageData.authenticate_key = "abcd123XYZ";
    mortgageData.tourId = tourid;

    postRecord(APIGetMortgageCalculator, mortgageData)
      .then((res) => {
        if (res.data[0].response.status === "success") {
          setMortgageResult(res.data[0].response.data);
        } else {
          setMortgageResult({});
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const MortgageCalclulator = () => {
    if (validateForm()) {
      CalculateMortgage();
    }
  };
  // const MortgageCalclulator = () => {
  //   CalculateMortgage();
  // };

  const viewFlyer = () => {
    window.open("/site/flyer/" + tourid, "_blank");
    // history.push(APIPath() + "agent-view-flyer-active/" + ThemeId + APIPath() + AgnetID);
  };
  const ListingPage = () => {
    window.open(
      APIPath() + "agent-my-listing/" + AgnetID + "/" + tourid,
      "_blank",
    );
    // history.push(APIPath() + "agent-my-listing/" + AgnetID);
  };
  const setVideoModal = (video) => {
    setOpenVideoModal(true);
    setVideoUrl(video);
  };
  const AreaSchool = () => {
    const caption = tourDetailsData.Caption; // Example: "350 Shady Glen Rd, Walnut Creek, CA 94596"
    const state = caption.split(" ").slice(-2, -1)[0];
    const zip = tourData.zipcode;
    const city = tourData.city;
    window.open(
      `https://nces.ed.gov/globallocator/index.asp?search=1&itemname=&city=${city}&State=${state}&zipcode=${zip}&miles=10&School=1&PrivSchool=1`,
      "_blank",
    );
  };

  // const AreaSchool = () => {
  //   const zip = tourData.zipcode;
  //   const url = `https://nces.ed.gov/globallocator/index.asp?search=1&State=BC&zipcode=${zip}&School=1&PrivSchool=1&miles=10&CS=240931FB","_blank"`;
  //   console.log("Show",url);
  //   window.open(
  //     `https://nces.ed.gov/globallocator/index.asp?search=1&State=BC&zipcode=${zip}&School=1&PrivSchool=1&miles=10&CS=240931FB`,
  //     "_blank"
  //   );
  // };
  const handleSvgLink = () => {
    window.open(
      "https://www.walkscore.com/score/dfds?utm_source=walkscore.com&utm_medium=score-badge&utm_campaign=ws_score_widget",
      "_blank",
    );
  };
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const options2 = {
    lazyLoad: true,
    loop: true,
    margin: 20,
    responsiveClass: true,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    autoplay: true,
    autoplayTimeout:
      Object.keys(slideSetting).length > 0
        ? slideSetting.transduration * 1000
        : 3500,
    autoplayHoverPause: false,
    autoHeight: true,
    mouseDrag: true,
    touchDrag: true,
    smartSpeed:
      Object.keys(slideSetting).length > 0
        ? slideSetting.transspeed * 1000
        : 2500,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },

      600: {
        items: 1,
      },

      1024: {
        items: 1,
      },

      1366: {
        items: 1,
      },
    },
  };
  const config = {
    type:
      Object.keys(panoSetting).length > 0
        ? panoSetting.panotype
        : "equirectangular",
    touchPanSpeedCoeffFactor:
      Object.keys(panoSetting).length > 0 ? panoSetting.panospeed : 1,
    maxLevel: Object.keys(panoSetting).length > 0 ? panoSetting.maxzoom : 100,
    showZoomCtrl:
      Object.keys(panoSetting).length > 0 && panoSetting.maxzoom === 1
        ? true
        : false,
    keyboardZoom:
      Object.keys(panoSetting).length > 0 && panoSetting.isKeyboardZoom === 1
        ? true
        : false,
    mouseZoom:
      Object.keys(panoSetting).length > 0 && panoSetting.isMouseZoom === 1
        ? true
        : false,
    autoRotate: -15,
    autoLoad: true,
    background: "#000000",
    hfov: 120,
    showZoomCtrl: true,
  };

  const setPanoModal = (pano) => {
    setOpenPanoromaModal(true);
    setPanoUrl(pano);
  };

  const defaultProps = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627,
    },
    zoom: 11,
  };
  // const getMapBounds = (map, maps, places) => {
  //     const bounds = new maps.LatLngBounds();

  //     places.forEach((place) => {
  //       bounds.extend(new maps.LatLng(
  //         place.geometry.location.lat,
  //         place.geometry.location.lng,
  //       ));
  //     });
  //     return bounds;
  //   };
  //   const bindResizeListener = (map, maps, bounds) => {
  //     maps.event.addDomListenerOnce(map, 'idle', () => {
  //       maps.event.addDomListener(window, 'resize', () => {
  //         map.fitBounds(bounds);
  //       });
  //     });
  //   };
  //   const handleApiLoaded = (map, maps, places) => {
  //     // Get bounds by our places
  //     const bounds = getMapBounds(map, maps, places);
  //     // Fit map to bounds
  //     map.fitBounds(bounds);
  //     // Bind the resize listener
  //     bindResizeListener(map, maps, bounds);
  //   };

  // }
  const handleInputMailChange = (event) => {
    const { name, value } = event.target;
    console.log(event.target.value);
    setSendMail({ ...sendMail, [name]: value });
  };
  const sendMailAgent = () => {
    setOpen(true);
    sendMail.authenticate_key = "abcd123XYZ";
    sendMail.tourId = tourid;
    sendMail.agentId = AgnetID;
    postRecord(APIGetContactAgent, sendMail)
      .then((res) => {
        if (res.data[0].response.status === "success") {
          setOpen(false);
          setMessage(res.data[0].response.message);
          setOpenSuccess(true);
          setSync(false);
          setSendMail({});
        } else {
          setOpen(false);
          setMessage(res.data[0].response.message);
          setOpenError(true);
          setSync(false);
        }
        setSync(true);
      })
      .catch((error) => {
        setOpen(false);
        setMessage("Error Occured !!");
        setOpenError(true);
      });
  };
  const amenityHandleDateChange = (event) => {
    console.log(event.target.value);
    const { name, value } = event.target;
    setAmenityData({ ...amenityData, [name]: value });
  };
  const amenityHandleTImeChange = (event) => {
    console.log(event.target.value);
    const { name, value } = event.target;
    setAmenityData({ ...amenityData, [name]: value });
  };
  const scheduleAppointment = () => {
    amenityData.authenticate_key = "abcd123XYZ";
    amenityData.tourId = tourid;
    setOpen(true);
    postRecord(APIGetScheduleAppointment, amenityData)
      .then((res) => {
        if (res.data[0].response.status === "success") {
          setOpen(false);
          setMessage(res.data[0].response.message);
          setOpenSuccess(true);
          setSync(false);
          setAmenityData({});
        } else {
          setMessage(res.data[0].response.message);
          setOpenError(true);
          setSync(false);
        }
        setSync(true);
      })
      .finally(() => {
        setOpen(false);
      });
  };
  const handleWebsite = (website) => {
    if (!website.startsWith("http://") && !website.startsWith("https://")) {
      website = "http://" + website;
    }
    window.open(website, "_blank");
  };

  const downloadDoc = (fileLink, name) => {
    const link = document.createElement("a");
    link.href = fileLink;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  };
  function formatPhoneNumber(phoneNumber) {
    // Remove all non-digit characters
    const cleaned = phoneNumber.replace(/\D/g, "");

    if (cleaned.length !== 10) {
      return phoneNumber;
    }
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
    )}`;
  }
  console.log("tourDetails-ANIL", tourDetailsData);
  return (
    <React.Fragment>
      <div class="wrapper theme1" id="home">
        <div class="wrapper_inner">
          <div class="header-box1">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="header-boxfull">
                    <div class="company-name" style={{ textTransform: "none" }}>
                      {tourDetailsData.Caption}
                    </div>
                    <div class="topmenu">
                      <nav
                        id="cssmenu"
                        className={`head_btm_menu ${mobileClass}`}
                      >
                        <div
                          id="menu-button"
                          onClick={() => setShow(!show)}
                        ></div>
                        <ul style={{ display: show ? "block" : "" }}>
                          <li>
                            <a
                              className="linkWithoutLink"
                              onClick={scrollToTop}
                            >
                              Home
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              onClick={(e) => scrollToElement(e, features)}
                            >
                              Features
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              onClick={(e) => scrollToElement(e, photos)}
                            >
                              Photos
                            </a>
                          </li>
                          {(threeDs?.code1 || threeDs?.code2) && (
                            <li>
                              <a
                                href="#"
                                onClick={(e) => scrollToElement(e, threeD)}
                              >
                                3D Walkthrough
                              </a>
                            </li>
                          )}

                          {panoromaData.length > 0 && (
                            <li>
                              <a
                                href="#"
                                onClick={(e) => scrollToElement(e, panorama)}
                              >
                                Panorama
                              </a>
                            </li>
                          )}
                          {videoData.length > 0 && (
                            <li>
                              <a
                                href="#"
                                onClick={(e) => scrollToElement(e, videos)}
                              >
                                Videos
                              </a>
                            </li>
                          )}
                          {!strict && (
                            <li>
                              <a
                                href="#"
                                onClick={(e) => scrollToElement(e, location)}
                              >
                                Location
                              </a>
                            </li>
                          )}
                          {floorPlanData.length > 0 && (
                            <li>
                              <a
                                href="#"
                                onClick={(e) => scrollToElement(e, floorPlans)}
                              >
                                Floor Plans
                              </a>
                            </li>
                          )}
                          {!strict && !mls && (
                            <li>
                              <a
                                href="#"
                                onClick={(e) => scrollToElement(e, presentedBy)}
                              >
                                Presented By
                              </a>
                            </li>
                          )}
                          {!mls && !strict && (
                            <>
                              <li>
                                <a className="linkWithoutLink">Details</a>
                                <ul>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={() =>
                                        setOpenProertyInfromation(true)
                                      }
                                    >
                                      Property Information
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={() => setOpenAmenties(true)}
                                    >
                                      Amenities
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={viewFlyer}
                                    >
                                      Printable Flyer
                                    </a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a
                                  href="#"
                                  onClick={(e) => scrollToElement(e, contact)}
                                >
                                  Contact
                                </a>
                                <ul>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={() => setopenAgentInfo(true)}
                                    >
                                      Agent Info
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={() => setopenAppointment(true)}
                                    >
                                      Schedule Appointment
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={ListingPage}
                                    >
                                      My Listings
                                    </a>
                                  </li>
                                  {facebookLink && (
                                    <li>
                                      <a href={facebookLink} target="_blank">
                                        Facebook Link
                                      </a>
                                    </li>
                                  )}
                                  {TwitterLink && (
                                    <li>
                                      <a href={TwitterLink} target="_blank">
                                        Twitter Link
                                      </a>
                                    </li>
                                  )}

                                  {youTubeLink && (
                                    <li>
                                      <a href={youTubeLink} target="_blank">
                                        Youtube Link
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </li>
                              <li>
                                <a className="linkWithoutLink">Tools</a>
                                <ul>
                                  {/* <li><a href="#map">Map View</a></li>
                                                            <li><a href="javascript:void()" >Arial View</a></li> */}
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={() => setOpenMortgage(true)}
                                    >
                                      {" "}
                                      Mortgage Calculator
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void()"
                                      onClick={() => setOpenWalkScore(true)}
                                    >
                                      Walk Score
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={
                                        tourDetails?.areaschoolslink ||
                                        tourDetails?.tourdetails
                                          ?.areaschoolslink
                                      }
                                    >
                                      Area School
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </>
                          )}
                        </ul>
                      </nav>
                    </div>
                    {/* <ReactAudioPlayer
                                            src={music && music}
                                            autoPlay={true}
                                            controls
                                        /> */}
                    <div class="Music-player-holder">
                      <div class="player">
                        <img id="button" onClick={togglePlay} src={playbtn} />
                        {/* <iframe src="https://olafwempe.com/mp3/silence/silence.mp3" type="audio/mp3" allow="autoplay" id="audio" style={{ display: "none" }}></iframe> */}
                        {music && (
                          <audio autoplay id="track1" loop>
                            <source type="audio/ogg" src={music} />
                            <source type="audio/mpeg" src={music} />
                          </audio>
                        )}
                      </div>
                      <div class="bar-c">
                        <div id="bar-1" class="bar noAnim"></div>
                        <div id="bar-2" class="bar noAnim"></div>
                        <div id="bar-3" class="bar noAnim"></div>
                        <div id="bar-4" class="bar noAnim"></div>
                        <div id="bar-5" class="bar noAnim"></div>
                        <div id="bar-6" class="bar noAnim"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {imageData.length > 0 ? (
            <OwlCarousel margin={10} {...options2}>
              {imageData.map((res) => (
                <div class="carousel-item active">
                  <img
                    src={res.imageurl}
                    style={{
                      filter:
                        "blur(" +
                        res.blur / 10 +
                        "px) brightness(" +
                        (res.brightness === 100 ? 10 : res.brightness) / 10 + // Corrected here
                        ") grayscale(" +
                        res.grayscale +
                        "%) contrast(" +
                        (res.contrast === 0 ? 1 : res.contrast) + // Corrected here
                        ") hue-rotate(" +
                        res.huerotate / 10 +
                        "rad) invert(" +
                        res.invert +
                        "%) opacity(" +
                        (res.opacity === 0 ? 100 : res.opacity) + // Corrected here
                        "%) saturate(" +
                        (res.saturation === 100 ? 10 : res.saturation) / 10 + // Corrected here
                        ") sepia(" +
                        res.sepia +
                        "%)",
                      transform: "rotate(" + res.rotate + "deg)",
                    }}
                  />
                  <div class="container">
                    <div class="carousel-caption"></div>
                  </div>
                </div>
              ))}
            </OwlCarousel>
          ) : (
            ""
          )}
          {/* <div id="carouselExampleIndicators" class="carousel slide carousel-fade" data-ride="carousel">
                        <div class="carousel-inner" role="listbox">
                            <div class="carousel-item active" style={{ backgroundImage: "url(" + banner1 + ")", backgroundPosition: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                            </div>
                            <div class="carousel-item" style={{ backgroundImage: "url(" + banner2 + ")", backgroundPosition: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                            </div>
                            <div class="carousel-item" style={{ backgroundImage: "url(" + banner3 + ")", backgroundPosition: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                            </div>
                            
                        </div>
                    </div> */}
          <div class="content">
            <div class="content_inner">
              <div class="full_width">
                <div class="full_width_inner">
                  <div class="bodycontent">
                    <div class="container">
                      <div class="row second_section">
                        <div class="col-sm-12">
                          <h3>{tourData.address}</h3>
                          <small>
                            {tourData.city}, {statename} {tourData.zipcode}
                          </small>
                          <h4>Description</h4>
                          <p
                            className="text-center"
                            dangerouslySetInnerHTML={{
                              __html:
                                (Object.keys(tourData).length > 0 &&
                                  tourData.description) ||
                                "N/A",
                            }}
                          ></p>
                        </div>
                      </div>
                      {/* <div
                        class=" row second_section third_section"
                        id="feature"
                        ref={features}
                      >
                        <div class="col-md-6 m-auto" ref={propertyRef}>
                          <h4>Description</h4>
                          <hr class="spacer30px"></hr>
                          <h5>
                            {tourDetails?.tourdetails?.description || "N/A"}
                          </h5>
                        </div>
                      </div> */}
                      <div
                        class="row second_section third_section"
                        id="feature"
                        ref={features}
                      >
                        {!strict && (
                          <>
                            <div class="col-md-6 m-auto" ref={propertyRef}>
                              <h4>Property Details</h4>
                              <hr class="spacer30px"></hr>
                              <ul>
                                <li>
                                  <strong>Status: </strong>
                                  {(Object.keys(tourDetailsData).length > 0 &&
                                    tourDetailsData.category_name === null) ||
                                  tourDetailsData.category_name === "" ? (
                                    <span style={{ marginLeft: "10px" }}></span>
                                  ) : (
                                    <span>{tourStatus ? tourStatus : ""}</span>
                                  )}
                                </li>

                                {Object.keys(tourDetailsData).length > 0 &&
                                tourDetailsData.Price != null &&
                                tourDetailsData.Price !== "" ? (
                                  <li>
                                    <strong>Price: </strong>

                                    <span>
                                      {tourDetailsData.Price
                                        ? `$${tourDetailsData.Price}`
                                        : ""}
                                    </span>
                                  </li>
                                ) : (
                                  <li>
                                    <strong>Price:</strong>
                                    <span style={{ marginLeft: "10px" }}>
                                      N/A
                                    </span>
                                  </li>
                                )}

                                {tourDetailsData.Beds !== null && (
                                  <li>
                                    <strong>Bedroom(s): </strong>

                                    <span>{tourDetailsData.Beds}</span>
                                  </li>
                                )}

                                {tourDetailsData.Baths !== null && (
                                  <li>
                                    <strong>Bathroom(s): </strong>
                                    <span>{tourDetailsData.Baths}</span>
                                  </li>
                                )}

                                <li>
                                  <strong>Square Feet: </strong>
                                  {Object.keys(tourDetailsData).length > 0 &&
                                  tourDetailsData.InteriorSqFt === null ? (
                                    <span style={{ marginLeft: "10px" }}>
                                      N/A
                                    </span>
                                  ) : (
                                    <span>{tourDetailsData.InteriorSqFt}</span>
                                  )}
                                </li>
                                {Object.keys(tourDetailsData).length > 0 &&
                                  tourDetailsData.Garage !== null && (
                                    <li>
                                      <strong>Garage: </strong>

                                      <span>{tourDetailsData.Garage}</span>
                                    </li>
                                  )}
                                <li>
                                  <strong>Year Built: </strong>
                                  {Object.keys(tourDetailsData).length > 0 &&
                                  tourDetailsData.YearBuilt === null ? (
                                    <span style={{ marginLeft: "10px" }}>
                                      N/A
                                    </span>
                                  ) : (
                                    <span>{tourDetailsData.YearBuilt}</span>
                                  )}
                                </li>
                                <li>
                                  <strong>Lot Size: </strong>
                                  {Object.keys(tourDetailsData).length > 0 &&
                                  tourDetailsData.LotSize === null ? (
                                    <span style={{ marginLeft: "10px" }}>
                                      N/A
                                    </span>
                                  ) : (
                                    // <span>{tourDetailsData.LotSize} Acre</span>
                                    <span>
  {tourDetailsData?.LotSize?.toLowerCase().includes("sqft")
    ? tourDetailsData.LotSize
    : `${tourDetailsData.LotSize} sqft`}
</span>
                                  )}
                                </li>
                                {Object.keys(tourDetailsData).length > 0 &&
                                  tourDetailsData.SchoolDistrict !== null && (
                                    <li>
                                      <strong>School District: </strong>

                                      <span>
                                        {tourDetailsData.SchoolDistrict}
                                      </span>
                                    </li>
                                  )}
                                <li>
                                  <strong>MLS#: </strong>
                                  {Object.keys(tourDetailsData).length > 0 &&
                                  tourDetailsData.MLS === null ? (
                                    <span style={{ marginLeft: "10px" }}>
                                      N/A
                                    </span>
                                  ) : (
                                    <span>{tourDetailsData.MLS}</span>
                                  )}
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                        <hr class="spacer30px" />
                        <hr class="spacer30px" />

                        <div class="col-sm-12 text-center sharethis">
                          <strong>SHARE THIS ON</strong> &nbsp;&nbsp;
                          <FacebookShareButton
                            url={
                              "https://www.virtualtourcafe.com/alpha/tour/theme-template/" +
                              ThemeId +
                              AgnetID
                            }
                          >
                            <i class="fab fa-facebook-f"></i>
                          </FacebookShareButton>
                          <LinkedinShareButton
                            url={
                              "https://www.virtualtourcafe.com/alpha/tour/theme-template/" +
                              ThemeId +
                              AgnetID
                            }
                          >
                            <i class="fab fa-linkedin-in"></i>
                          </LinkedinShareButton>
                          <WhatsappShareButton
                            url={
                              "https://www.virtualtourcafe.com/alpha/tour/theme-template/" +
                              ThemeId +
                              AgnetID
                            }
                          >
                            <i
                              style={{ backgroundColor: "rgb(37, 211, 102)" }}
                              class="fab fa-whatsapp"
                            ></i>
                          </WhatsappShareButton>
                          <TwitterShareButton
                            url={
                              "https://www.virtualtourcafe.com/alpha/tour/theme-template/" +
                              ThemeId +
                              AgnetID
                            }
                          >
                            <i class="fab fa-twitter"></i>
                          </TwitterShareButton>
                          {/* <a href={facebookLink} target="_blank"><i class="fab fa-facebook-f"></i></a>
                                                    <a href="#"><i class="fab fa-linkedin-in"></i></a>
                                                    <a href="#"><i class="fab fa-pinterest-p"></i></a>
                                                    <a href={TwitterLink} target="_blank"><i class="fab fa-twitter"></i></a>
                                                    <a href="#"><i class="fab fa-google-plus-g"></i></a> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {documents && documents.length > 0 ? (
                    <div class="bodycontent_gallery_centerbox" id="videos">
                      <h4>Documents</h4>
                      <hr class="spacer30px"></hr>
                      <ul>
                        {documents &&
                          documents.length > 0 &&
                          documents.map((res) => (
                            <li>
                              <div class="gallerybox">
                                <div class="image-holder video-holder">
                                  <img
                                    src="https://virtualtourcafe.com/images/documents.png?1590647111"
                                    style={{
                                      marginTop: "-18px",
                                      height: "100%",
                                    }}
                                  />

                                  <span class="gallery_title">Doc</span>
                                  <div class="overlay">
                                    <div class="button">
                                      <p>{res.doc_name}</p>
                                      <a
                                        onClick={() =>
                                          downloadDoc(
                                            res.doc_link,
                                            res.doc_name,
                                          )
                                        }
                                        data-title={res.doc_name}
                                      >
                                        <img src={zoomIcon} alt="" />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                      </ul>
                      <hr class="spacer1px" />
                    </div>
                  ) : (
                    ""
                  )}
                  <hr class="spacer30px"></hr>
                  {imageData.length > 0 ? (
                    <div class="bodycontent_gallery" id="photos" ref={photos}>
                      <h4>Photo Gallery</h4>
                      <hr class="spacer30px"></hr>
                      <ul>
                        {Object.keys(imageData).length > 0
                          ? imageData.map((res) => (
                              <li>
                                <div class="gallerybox">
                                  <div class="image-holder">
                                    <div class="gallery_bgimage">
                                      &nbsp;
                                      <img
                                        src={res.imageurl}
                                        style={{
                                          marginTop: "-18px",
                                          height: "300px",
                                          filter:
                                            "blur(" +
                                            res.blur / 10 +
                                            "px) brightness(" +
                                            (res.brightness === 100
                                              ? 10
                                              : res.brightness) /
                                              10 + // Corrected here
                                            ") grayscale(" +
                                            res.grayscale +
                                            "%) contrast(" +
                                            (res.contrast === 0
                                              ? 1
                                              : res.contrast) + // Corrected here
                                            ") hue-rotate(" +
                                            res.huerotate / 10 +
                                            "rad) invert(" +
                                            res.invert +
                                            "%) opacity(" +
                                            (res.opacity === 0
                                              ? 100
                                              : res.opacity) + // Corrected here
                                            "%) saturate(" +
                                            (res.saturation === 100
                                              ? 10
                                              : res.saturation) /
                                              10 + // Corrected here
                                            ") sepia(" +
                                            res.sepia +
                                            "%)",
                                          transform:
                                            "rotate(" + res.rotate + "deg)",
                                        }}
                                      />
                                    </div>
                                    <div class="overlay">
                                      <div class="button">
                                        <p>{res.caption}</p>
                                        <a
                                          class="example-image-link"
                                          href={res.imageurl}
                                          data-lightbox="example-1"
                                          data-title={res.caption}
                                        >
                                          <img src={zoomIcon} alt="" />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))
                          : ""}
                        {/* <li>
                                                        <div class="gallerybox">
                                                            <div class="image-holder">
                                                                <div class="gallery_bgimage" style={{ backgroundImage: "url(" + banner3 + ")", backgroundPosition: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} >&nbsp;
                                                                </div>
                                                                <span class="gallery_title">Image</span>
                                                                <div class="overlay">
                                                                    <div class="button">
                                                                        <p>Title Goes Here</p><a class="example-image-link"
                                                                            href={about1} data-lightbox="example-1"
                                                                            data-title="Title Goes Here">
                                                                            <img src={zoomIcon}
                                                                                alt="" /></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li> */}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  <hr class="spacer30px" />
                  {panoromaData.length > 0 ? (
                    <div
                      class="bodycontent_gallery bodycontent_gallery_panaroma"
                      id="panaroma"
                      ref={panorama}
                    >
                      <h4>Panorama Gallery</h4>
                      <hr class="spacer30px"></hr>
                      <ul>
                        {Object.keys(panoromaData).length > 0
                          ? panoromaData.map((res) => (
                              <li>
                                <div class="gallerybox">
                                  <div class="image-holder">
                                    <div class="gallery_bgimage">
                                      &nbsp;
                                      <img
                                        src={res.panurl}
                                        style={{
                                          marginTop: "-18px",
                                          height: "300px",
                                        }}
                                      />
                                    </div>
                                    <div class="overlay">
                                      <div class="button">
                                        <p>{res.caption}</p>
                                        <a
                                          data-title={res.caption}
                                          onClick={() =>
                                            setPanoModal(res.panurl)
                                          }
                                        >
                                          <img src={zoomIcon} alt="" />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))
                          : ""}
                        {/* <li>
                                                        <div class="gallerybox">
                                                            <div class="image-holder">
                                                                <div class="gallery_bgimage" style={{ backgroundImage: "url(" + banner3 + ")", backgroundPosition: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} >&nbsp;
                                                                </div>
                                                                <span class="gallery_title">Image</span>
                                                                <div class="overlay">
                                                                    <div class="button">
                                                                        <p>Title Goes Here</p><a class="example-image-link"
                                                                            href={about1} data-lightbox="example-1"
                                                                            data-title="Title Goes Here">
                                                                            <img src={zoomIcon}
                                                                                alt="" /></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li> */}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  <hr class="spacer30px"></hr>

                  {videoData.length > 0 ? (
                    <div
                      class="bodycontent_gallery_centerbox"
                      id="videos"
                      ref={videos}
                    >
                      <h4>Video Gallery</h4>
                      <hr class="spacer30px"></hr>

                      <ul>
                        {videoData.map((res) => (
                          <li>
                            <div class="gallerybox">
                              <div class="image-holder video-holder">
                                <img src={res.thumbnail} alt="" />

                                <span class="gallery_title">Video</span>
                                <div class="overlay">
                                  <div class="button">
                                    <p>{res.caption}</p>
                                    <a
                                      onClick={() => setVideoModal(res)}
                                      data-title={res.caption}
                                    >
                                      <img src={playicon} alt="" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <hr class="spacer1px" />
                    </div>
                  ) : (
                    ""
                  )}
                  {threeDs?.code1 || threeDs?.code2 ? (
                    <div
                      class="bodycontent_gallery_centerbox  mx-2"
                      id="videos"
                      ref={threeD}
                    >
                      <h4>3D WalkThrough</h4>
                      <hr class="spacer30px"></hr>
                      <div className="row mx-2 centered">
                        {threeDs?.code1 && (
                          <div className="col-6">
                            <div
                              class="threeDContainer"
                              dangerouslySetInnerHTML={{
                                __html: threeDs?.code1 && threeDs?.code1,
                              }}
                            ></div>
                          </div>
                        )}

                        {threeDs?.code2 && (
                          <div className="col-6">
                            <div
                              class="threeDContainer"
                              dangerouslySetInnerHTML={{
                                __html: threeDs?.code2 && threeDs?.code2,
                              }}
                            ></div>
                          </div>
                        )}
                      </div>

                      <hr class="spacer1px" />
                    </div>
                  ) : (
                    ""
                  )}
                  <hr class="spacer30px" />

                  {floorPlanData.length > 0 ? (
                    <div
                      class="bodycontent_gallery bodycontent_gallery_floor"
                      id="photos"
                      ref={floorPlans}
                    >
                      <h4>Floor Plans</h4>
                      <hr class="spacer30px"></hr>

                      <ul>
                        {Object.keys(floorPlanData).length > 0
                          ? floorPlanData.map((res) => (
                              <li>
                                <div class="gallerybox">
                                  <div class="image-holder">
                                    <div class="gallery_bgimage">
                                      &nbsp;
                                      <img
                                        src={res.imageurl}
                                        style={{
                                          marginTop: "-18px",
                                          height: "300px",
                                        }}
                                      />
                                    </div>
                                    <div class="overlay">
                                      <div class="button">
                                        <p>{res.caption}</p>
                                        <a
                                          class="example-image-link"
                                          href={res.imageurl}
                                          data-lightbox="example-1"
                                          data-title={res.caption}
                                        >
                                          <img src={zoomIcon} alt="" />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))
                          : ""}
                        {/* <li>
                                                        <div class="gallerybox">
                                                            <div class="image-holder">
                                                                <div class="gallery_bgimage" style={{ backgroundImage: "url(" + banner3 + ")", backgroundPosition: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} >&nbsp;
                                                                </div>
                                                                <span class="gallery_title">Image</span>
                                                                <div class="overlay">
                                                                    <div class="button">
                                                                        <p>Title Goes Here</p><a class="example-image-link"
                                                                            href={about1} data-lightbox="example-1"
                                                                            data-title="Title Goes Here">
                                                                            <img src={zoomIcon}
                                                                                alt="" /></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li> */}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  <hr class="spacer30px" />

                  {!strict && (
                    <div
                      class="bodycontent_location"
                      id="location"
                      ref={location}
                    >
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12">
                            <h4>Property Location</h4>
                            <hr class="spacer30px"></hr>
                          </div>
                        </div>
                      </div>

                      <div class="googlemapframe">
                        <div class="google-maps">
                          <div
                            ref={mapRef}
                            id="map"
                            style={{ width: "100%", height: "450px" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}
                  <hr class="spacer1px" />
                  {!mls && !strict && (
                    <div
                      class="bodycontent_agent"
                      id="presented"
                      ref={presentedBy}
                    >
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12">
                            <h4>Presented By</h4>
                          </div>
                        </div>
                        <hr class="spacer20px" />

                        <div class="row">
                          <div class="col-sm-4">
                            <div class="profile-photo">
                              {Object.keys(agentProfile).length > 0 &&
                              tourData.useAgentPic == 1 ? (
                                <img
                                  src={agentProfile.agent_profile.profile_img}
                                  alt=""
                                  title=""
                                />
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={250}
                                  height={70}
                                />
                              )}
                            </div>
                          </div>
                          <div class="col-sm-8 agent_sectionbody">
                            {Object.keys(agentProfile).length > 0 ? (
                              <h5>{agentProfile.agent_profile.name}</h5>
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                            <hr class=" spacer20px" />
                            {Object.keys(agentProfile).length > 0 ? (
                              <h6>{agentProfile.company_details.company}</h6>
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                            {Object.keys(agentProfile).length > 0 ? (
                              <small>
                                <i class="fas fa-phone-alt"></i>&nbsp;&nbsp;{" "}
                                {agentProfile.mobile &&
                                  formatPhoneNumber(agentProfile.mobile)}
                              </small>
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                            {Object.keys(agentProfile).length > 0 ? (
                              <small>
                                <i class="fa fa-id-card"></i>&nbsp;&nbsp;{" "}
                                {agentProfile.email}
                              </small>
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                            {Object.keys(agentProfile).length > 0 ? (
                              <small>
                                <i class="fa fa-id-card"></i>&nbsp;&nbsp; #
                                {agentProfile.licenceno}
                              </small>
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                            <hr class=" spacer20px" />
                            <a
                              href={"mailto:" + agentProfile.email}
                              class="agentbtn"
                            >
                              <i class="far fa-envelope"></i> Email Me
                            </a>
                            {agentProfile?.company_details?.website && (
                              <a
                                href="javascript:void()"
                                style={{ marginLeft: "10px" }}
                                onClick={(e) =>
                                  handleWebsite(
                                    agentProfile.company_details.website,
                                  )
                                }
                                class="agentbtn"
                              >
                                <i class="far fa-globe"></i> My Website
                              </a>
                            )}

                            {tourData.announcements &&
                              tourData.announcements.length > 0 && (
                                <div className="pull-left">
                                  <i class="fas fa-volume-up"></i>
                                  <a
                                    href="javascript:void(0);"
                                    onClick={() =>
                                      setOpenHouseModal(!openHouseModal)
                                    }
                                  >
                                    Open House Announcement
                                  </a>
                                </div>
                              )}
                            <hr class=" spacer20px" />
                            <p>{agentProfile.profile_content}</p>
                          </div>
                        </div>
                        {Object.keys(coAgentData).length > 0 && (
                          <div class="row">
                            <div class="col-sm-4">
                              <div class="profile-photo">
                                {Object.keys(coAgentData).length > 0 ? (
                                  <img
                                    src={coAgentData.profile_img}
                                    alt=""
                                    title=""
                                    style={{ objectFit: "contain" }}
                                  />
                                ) : (
                                  <Skeleton
                                    variant="text"
                                    width={250}
                                    height={70}
                                  />
                                )}
                              </div>
                            </div>
                            <div class="col-sm-8 agent_sectionbody">
                              {Object.keys(coAgentData).length > 0 ? (
                                <h5>{coAgentData.name}</h5>
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                              <hr class=" spacer20px" />
                              {Object.keys(coAgentData).length > 0 ? (
                                <h6>{coAgentData.company}</h6>
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                              {Object.keys(coAgentData).length > 0 ? (
                                <small>
                                  <i class="fas fa-phone-alt"></i>&nbsp;&nbsp;{" "}
                                  {coAgentData.mobile}
                                </small>
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                              {Object.keys(coAgentData).length > 0 ? (
                                <small>
                                  <i class="fa fa-id-card"></i>&nbsp;&nbsp;{" "}
                                  {coAgentData.email}
                                </small>
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                              {Object.keys(coAgentData).length > 0 ? (
                                <small>
                                  <i class="fa fa-id-card"></i>&nbsp;&nbsp; #
                                  {coAgentData.licenceno}
                                </small>
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                              <hr class=" spacer20px" />
                              <a
                                href={"mailto:" + coAgentData.email}
                                class="agentbtn"
                              >
                                <i class="far fa-envelope"></i> Email Me
                              </a>
                              {coAgentData?.website && (
                                <a
                                  href="javascript:void()"
                                  style={{ marginLeft: "10px" }}
                                  onClick={(e) =>
                                    handleWebsite(coAgentData.website)
                                  }
                                  class="agentbtn"
                                >
                                  <i class="far fa-globe"></i> My Website
                                </a>
                              )}

                              <hr class=" spacer20px" />
                              <p>{coAgentData[0]?.profile}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <hr class="spacer1px" />
                  {!mls && !strict && tourData.showleadcapture == 1 && (
                    <div
                      class="bodycontent_contact"
                      id="contact"
                      ref={contact}
                      style={{
                        backgroundImage: "url(" + mission_bg + ")",
                        backgroundPosition: "fixed",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12">
                            <h4>Contact</h4>
                            <hr class="spacer30px"></hr>
                          </div>
                        </div>
                        <hr class="spacer20px" />

                        <div class="row">
                          <div class="col-lg-12 m-auto">
                            <div class="bgwhite-btmpanel">
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="contact_left">
                                    {tourData.useCompanyPic == 1 && (
                                      <img
                                        src={
                                          agentProfile.company_details
                                            .companylogo
                                        }
                                        alt=""
                                      />
                                    )}

                                    <h5>
                                      {Object.keys(agentProfile).length > 0 ? (
                                        // agentProfile.agent_profile.name
                                        agentProfile.company_details.company
                                      ) : (
                                        <Skeleton
                                          variant="text"
                                          width={150}
                                          height={50}
                                          style={{ background: "#bbbbbb" }}
                                        />
                                      )}
                                    </h5>
                                    <p>
                                      {Object.keys(agentProfile).length > 0 ? (
                                        <a href={`tel:${agentProfile.mobile}`}>
                                          <i class="fas fa-phone-alt"></i>
                                          {agentProfile.mobile &&
                                            formatPhoneNumber(
                                              agentProfile.mobile,
                                            )}
                                        </a>
                                      ) : (
                                        <Skeleton
                                          variant="text"
                                          width={150}
                                          height={50}
                                          style={{ background: "#bbbbbb" }}
                                        />
                                      )}
                                      <br />
                                      {Object.keys(agentProfile).length > 0 ? (
                                        <a
                                          href={`mailto:${agentProfile.email}`}
                                        >
                                          <i class="fa fa-envelope"></i>
                                          {agentProfile.email}
                                        </a>
                                      ) : (
                                        <Skeleton
                                          variant="text"
                                          width={150}
                                          height={50}
                                          style={{ background: "#bbbbbb" }}
                                        />
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-8">
                                  <div class="contact_right">
                                    <form
                                      onSubmit={(event) => {
                                        event.preventDefault();
                                        sendMailAgent();
                                      }}
                                    >
                                      <ul>
                                        <li>
                                          <input
                                            type="text"
                                            placeholder="First Name *"
                                            class="inputbox"
                                            name="first_name"
                                            value={sendMail.first_name}
                                            onChange={handleInputMailChange}
                                          />
                                        </li>
                                        <li>
                                          <input
                                            name="last_name"
                                            type="text"
                                            placeholder="Last Name *"
                                            class="inputbox"
                                            value={sendMail.last_name}
                                            onChange={handleInputMailChange}
                                          />
                                        </li>
                                        <li>
                                          <input
                                            name="contact_email"
                                            type="email"
                                            placeholder="Your Email *"
                                            class="inputbox"
                                            value={sendMail.contact_email}
                                            onChange={handleInputMailChange}
                                          />
                                        </li>
                                        <li>
                                          <textarea
                                            name="comments"
                                            cols=""
                                            rows=""
                                            value={sendMail.comments}
                                            placeholder="Message"
                                            class="inputbox"
                                            onChange={handleInputMailChange}
                                          ></textarea>
                                        </li>
                                        <li>
                                          <button
                                            type="submit"
                                            class="agentbtn"
                                          >
                                            Submit
                                            <i
                                              class="fas fa-paper-plane"
                                              style={{ marginLeft: "10px" }}
                                            ></i>
                                          </button>
                                        </li>
                                      </ul>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div class="bodycontent_footerbtm">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-6 footerbtm_left">
                          <img src={footericon1} alt="" />{" "}
                          <img src={footericon2} alt="" />
                          <br />
                          Information deemed reliable but not guaranteed
                          {!strict && (
                            <>
                              <br />
                              &copy; {new Date().getFullYear()}
                              {"    "}
                              <a
                                href="http://virtualtourcafe.com/"
                                target="_blank"
                              >
                                VirtualTourCafe
                              </a>
                              <br />
                            </>
                          )}
                        </div>
                        {!strict && (
                          <div class="col-md-6 footerbtm_right">
                            <span>Powered by</span>{" "}
                            <img src={vtcLogoTop} alt="" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          href="#"
          class="back-to-top"
          onClick={scrollToTop}
          style={{ display: "none" }}
        >
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
        </a>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openError}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {message}
        </Alert>
      </Snackbar>
      <Dialog
        maxWidth={maxWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openAgentinfo}
      >
        <DialogTitle id="customized-dialog-title">
          Agent Info
          <CancelIcon
            onClick={() => setopenAgentInfo(false)}
            style={{ float: "right", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div class="container">
            <div className="row">
              <div className="col-6">
                <div class="agent_pop_main">
                  <div class="">
                    <div class="browse_img_head">
                      <h5>Agent Info</h5>
                    </div>
                    <div class="menu_opt_sec">
                      <div class="mar_top row">
                        <div class="col-6">
                          <div class="app_preview">
                            {Object.keys(agentProfile).length > 0 ? (
                              <img
                                src={agentProfile.agent_profile.profile_img}
                                alt=""
                                title=""
                                style={{ width: "100%" }}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                width={250}
                                height={70}
                              />
                            )}
                          </div>
                        </div>
                        <div class="col-6">
                          <p>
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.agent_profile.name
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </p>
                          <p>
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.company_details.company
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </p>
                          <p>
                            Mobile:{" "}
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.mobile
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </p>
                          <p>
                            Email:
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.email
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </p>
                          <p>
                            Office:{" "}
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.company_details.officephone
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </p>
                          <p>
                            License No:{" "}
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.licenceno
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </p>
                          <a
                            href={agentProfile.company_details.website}
                            target="_blank"
                          >
                            Website:{" "}
                            {Object.keys(agentProfile).length > 0 ? (
                              agentProfile.company_details.website
                            ) : (
                              <Skeleton
                                variant="text"
                                width={150}
                                height={20}
                                style={{ background: "#bbbbbb" }}
                              />
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* <div class="browse_img_head">
                                        <h5>Profile</h5>
                                    </div>
                                    <div class="menu_opt_sec">
                                        <div class="mar_top row">
                                            <div class="col-lg-12 col-md-12">
                                                <p style={{ textAlign: "justify" }}>In the Tours/Advanced/Co-Listing Agent section that co-listing agents photo is being distorted. Please take a look and correct his so that the co-listing agent photo is properly proportional the same as the listing agent photo. In the Tours/Advanced/Co-Listing Agent section that co-listing agents photo is being distorted. Please take a look and correct his so that the co-listing agent photo is properly proportional the same as the listing agent photo. In the Tours/Advanced/Co-Listing Agent section that co-listing agents photo is being distorted. Please take a look and correct his so that the co-listing agent photo is properly proportional the same as the listing agent photo.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="browse_img_head">
                                        <h5>Credentials</h5>
                                    </div>
                                    <div class="menu_opt_sec">
                                        <div class="mar_top row">
                                            <div class="col-lg-12 col-md-12">
                                                <p>N/A</p>
                                            </div>
                                        </div>
                                    </div> */}
                  </div>
                </div>
              </div>
              {Object.keys(coAgentData).length > 0 && (
                <div className="col-6">
                  <div class="agent_pop_main">
                    <div class="">
                      <div class="browse_img_head">
                        <h5>Co-Agent Info</h5>
                      </div>
                      <div class="menu_opt_sec">
                        <div class="mar_top row">
                          <div class="col-6">
                            <div class="app_preview">
                              {Object.keys(agentProfile).length > 0 ? (
                                <img
                                  src={coAgentData.profile_img}
                                  alt=""
                                  title=""
                                  style={{ width: "100%" }}
                                />
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={250}
                                  height={70}
                                />
                              )}
                            </div>
                          </div>
                          <div class="col-6">
                            <p>
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.name
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </p>
                            <p>
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.company
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </p>
                            <p>
                              Mobile:{" "}
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.mobile
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </p>
                            <p>
                              Email:
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.email
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </p>
                            <p>
                              Office:{" "}
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.officephone
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </p>
                            <p>
                              License No:{" "}
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.licenceno
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </p>
                            <a href={coAgentData.website} target="_blank">
                              Website:{" "}
                              {Object.keys(coAgentData).length > 0 ? (
                                coAgentData.website
                              ) : (
                                <Skeleton
                                  variant="text"
                                  width={150}
                                  height={20}
                                  style={{ background: "#bbbbbb" }}
                                />
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                      {/* <div class="browse_img_head">
                                        <h5>Profile</h5>
                                    </div>
                                    <div class="menu_opt_sec">
                                        <div class="mar_top row">
                                            <div class="col-lg-12 col-md-12">
                                                <p style={{ textAlign: "justify" }}>In the Tours/Advanced/Co-Listing Agent section that co-listing agents photo is being distorted. Please take a look and correct his so that the co-listing agent photo is properly proportional the same as the listing agent photo. In the Tours/Advanced/Co-Listing Agent section that co-listing agents photo is being distorted. Please take a look and correct his so that the co-listing agent photo is properly proportional the same as the listing agent photo. In the Tours/Advanced/Co-Listing Agent section that co-listing agents photo is being distorted. Please take a look and correct his so that the co-listing agent photo is properly proportional the same as the listing agent photo.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="browse_img_head">
                                        <h5>Credentials</h5>
                                    </div>
                                    <div class="menu_opt_sec">
                                        <div class="mar_top row">
                                            <div class="col-lg-12 col-md-12">
                                                <p>N/A</p>
                                            </div>
                                        </div>
                                    </div> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={maxWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openPropertyInformation}
      >
        <DialogTitle id="customized-dialog-title">
          Property Information
          <CancelIcon
            onClick={() => setOpenProertyInfromation(false)}
            style={{ float: "right", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div class="container">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                //saveCompanyBanner();
              }}
            >
              <div class="agent_pop_main">
                <div class="">
                  <div class="browse_img_head">
                    <h5>Features</h5>
                  </div>
                  <div class="menu_opt_sec">
                    <div class="mar_top row">
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>Bedrooms:</p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.Beds === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.Beds}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>
                                Square footage:
                              </p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.InteriorSqFt === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.InteriorSqFt}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>MLS #:</p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.MLS === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.MLS}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>
                                Sub Division:
                              </p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourData).length > 0 &&
                              tourData.subdivision === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourData.subdivision}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>Bathrooms:</p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.Baths === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.Baths}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>Year Built: </p>
                            </div>
                            <div class="col-lg-6">
                              {/* {(Object.keys(tourDetailsData).length > 0 || tourDetailsData.YearBuilt === "") ? (
                                                                <span>N/A</span>
                                                            ) : (
                                                                <span>{tourDetailsData.YearBuilt}</span>
                                                            )} */}
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.YearBuilt === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.YearBuilt}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>
                                Property Type:
                              </p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.PropertyType === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.PropertyType}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>
                                School District:
                              </p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.SchoolDistrict === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.SchoolDistrict}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>Lots Size:</p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.LotSize === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.LotSize}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>
                                Parking Space:
                              </p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourData).length > 0 &&
                              tourData.parkingspaces === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourData.parkingspaces}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>garage Size:</p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 &&
                              tourDetailsData.Garage === null ? (
                                <spna>N/A</spna>
                              ) : (
                                <span>{tourDetailsData.Garage}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="app_preview">
                          <div class="row">
                            <div class="col-lg-6">
                              <p style={{ marginLeft: "10px" }}>Status:</p>
                            </div>
                            <div class="col-lg-6">
                              {Object.keys(tourDetailsData).length > 0 ? (
                                <span>{category}</span>
                              ) : (
                                "N/A"
                              )}
                            </div>
                          </div>
                          {/* {(Object.keys(tourDetailsData).length > 0 || tourDetailsData.Status === "") ? (
                                                        "n/a"
                                                    ) : (
                                                        <span>{tourDetailsData.Status}</span>
                                                    )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="browse_img_head">
                    <h5>Description</h5>
                  </div>
                  <div class="menu_opt_sec">
                    <div class="mar_top row">
                      {Object.keys(tourData).length > 0 ? (
                        <p
                          style={{ marginLeft: "15px" }}
                          dangerouslySetInnerHTML={{
                            __html:
                              Object.keys(tourData).length > 0 &&
                              tourData.description,
                          }}
                        ></p>
                      ) : (
                        ""
                      )}
                      {/* {(Object.keys(tourDetailsData).length > 0 && tourDetailsData.Garage === "") ? (
                                                <spna>N/A</spna>
                                            ) : (
                                                <span>{tourDetailsData.Garage}</span>
                                            )} */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={largeWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openAppointment}
      >
        <DialogTitle id="customized-dialog-title">
          Schedule an Appointment
          <CancelIcon
            onClick={() => setopenAppointment(false)}
            style={{ float: "right", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div class="container">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                scheduleAppointment();
              }}
            >
              <div class="agent_pop_main">
                <div class="">
                  <div class="menu_opt_sec">
                    <div class="mar_top row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">First Name *</div>
                          <div class="col-md-8">
                            <input
                              type="text"
                              name="firstname"
                              value={amenityData.firstname}
                              onChange={amenityHandleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Email *</div>
                          <div class="col-md-8">
                            <input
                              type="email"
                              name="contactemail"
                              value={amenityData.contactemail}
                              class="form-control"
                              onChange={amenityHandleChange}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mar_top row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Last Name *</div>
                          <div class="col-md-8">
                            <input
                              type="text"
                              name="lastname"
                              value={amenityData.lastname}
                              class="form-control"
                              required
                              onChange={amenityHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Phone</div>
                          <div class="col-md-8">
                            <input
                              type="tel"
                              name="txtPhone"
                              value={amenityData.txtPhone}
                              class="form-control"
                              onChange={amenityHandleChange}
                              minlength="10"
                              maxlength="12"
                            />
                          </div>
                          {/* pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" */}
                        </div>
                      </div>
                      <div class="col-md-6">
                        <p>Desired Date and Time for Appointment *</p>
                      </div>
                    </div>
                    <div class="mar_top row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Date</div>
                          <div class="col-md-8">
                            <input
                              type="date"
                              name="date"
                              value={amenityData.date}
                              class="form-control"
                              onChange={amenityHandleDateChange}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Time</div>
                          <div class="col-md-8">
                            <input
                              type="time"
                              name="time"
                              value={amenityData.time}
                              class="form-control"
                              onChange={amenityHandleTImeChange}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <input
                          type="checkbox"
                          id="chkNotify"
                          name="chkNotify"
                          value={amenityData.chkNotify}
                          style={{ marginBottom: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>
                          Notify me when there is an open house for this house.
                        </span>
                      </div>
                    </div>
                    <div class="mar_top row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Best time to reach you</div>
                          <div class="col-md-8">
                            <select
                              class="form-control"
                              name="selMettingTime"
                              onChange={amenityHandleChange}
                              id="selMettingTime"
                            >
                              <option value="0">Select</option>
                              <option value="Morning">Morning </option>
                              <option value="AfterNoon">AfterNoon</option>
                              <option value="Evening">Evening</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">Contact me by</div>
                          <div class="col-md-8">
                            <select
                              class="form-control"
                              name="selContactType"
                              onChange={amenityHandleChange}
                              id="selContactType"
                            >
                              <option value="0">Select</option>
                              <option value="Phone">Phone </option>
                              <option value="Email">Email</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mar_top row">
                      <div class="col-md-2">
                        <p>Comments</p>
                      </div>
                      <div class="col-md-10">
                        <textarea
                          required
                          type="text"
                          name="txaComment"
                          value={amenityData.txaComment}
                          class="form-control"
                          onChange={amenityHandleChange}
                          style={{ minHeight: "100px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div></div>
                  <div class="browse_img_head">
                    <button type="submit" class="agentbtn">
                      Save
                    </button>
                  </div>
                  <p>* Required Fields</p>
                </div>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={maxWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openAmenties}
      >
        <DialogTitle id="customized-dialog-title">
          Amenities
          <CancelIcon
            onClick={() => setOpenAmenties(false)}
            style={{ float: "right", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div class="container">
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <div class="agent_pop_main">
                {Object.keys(amenities).length > 0 &&
                  amenities.appliances.length > 0 && (
                    <div class="">
                      <div class="browse_img_head">
                        <h5>Appliances</h5>
                      </div>
                      <div class="menu_opt_sec">
                        <div class="mar_top row">
                          {Object.keys(amenities).length > 0 &&
                            amenities.appliances.length > 0 &&
                            amenities.appliances.map((res) => (
                              <div class="col-lg-4 col-md-4">
                                <div class="app_preview">
                                  <p style={{ marginLeft: "10px" }}>
                                    {res.amenityname}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
                {Object.keys(amenities).length > 0 &&
                  amenities.community.length > 0 && (
                    <div class="">
                      <div class="browse_img_head">
                        <h5>Community</h5>
                      </div>
                      <div class="menu_opt_sec">
                        <div class="mar_top row">
                          {Object.keys(amenities).length > 0 &&
                            amenities.community.length > 0 &&
                            amenities.community.map((res) => (
                              <div class="col-lg-4 col-md-4">
                                <div class="app_preview">
                                  <p style={{ marginLeft: "10px" }}>
                                    {res.amenityname}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
                {Object.keys(amenities).length > 0 &&
                  amenities.exterior.length > 0 && (
                    <div class="">
                      <div class="browse_img_head">
                        <h5>Exterior</h5>
                      </div>
                      <div class="menu_opt_sec">
                        <div class="mar_top row">
                          {Object.keys(amenities).length > 0 &&
                            amenities.exterior.length > 0 &&
                            amenities.exterior.map((res) => (
                              <div class="col-lg-4 col-md-4">
                                <div class="app_preview">
                                  <p style={{ marginLeft: "10px" }}>
                                    {res.amenityname}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
                {Object.keys(amenities).length > 0 &&
                  amenities.interior.length > 0 && (
                    <div class="">
                      <div class="browse_img_head">
                        <h5>Interior</h5>
                      </div>
                      <div class="menu_opt_sec">
                        <div class="mar_top row">
                          {Object.keys(amenities).length > 0 &&
                            amenities.interior.length > 0 &&
                            amenities.interior.map((res) => (
                              <div class="col-lg-4 col-md-4">
                                <div class="app_preview">
                                  <p style={{ marginLeft: "10px" }}>
                                    {res.amenityname}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={largeWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openMortagage}
      >
        <DialogTitle id="customized-dialog-title">
          Mortgage Calculator
          <CancelIcon
            onClick={() => setOpenMortgage(false)}
            style={{ float: "right", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div class="container">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                MortgageCalclulator();
              }}
            >
              <div class="agent_pop_main">
                <div class="">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="browse_img_head">
                        <h5>Mortgage Information</h5>
                      </div>
                      <div
                        class="row"
                        style={{ marginTop: "10px", marginBottom: "10px" }}
                      >
                        <div class="col-md-5">Mortgage Length(years)</div>
                        <div class="col-md-7">
                          <input
                            type="text"
                            name="length"
                            value={mortgageData.length}
                            class="form-control"
                            onChange={inputHandleChange}
                            required
                          />
                          {errors.length && (
                            <p style={{ color: "red" }}>{errors.length}</p>
                          )}
                        </div>
                      </div>
                      <div
                        class="row"
                        style={{ marginTop: "10px", marginBottom: "10px" }}
                      >
                        <div class="col-md-5">Interest Rate(%) *</div>
                        <div class="col-md-7">
                          <input
                            type="text"
                            name="rate"
                            onChange={inputHandleChange}
                            value={mortgageData.rate}
                            class="form-control"
                            required
                          />
                          {errors.rate && (
                            <p style={{ color: "red" }}>{errors.rate}</p>
                          )}
                        </div>
                      </div>
                      <div
                        class="row"
                        style={{ marginTop: "10px", marginBottom: "10px" }}
                      >
                        <div class="col-md-5">House Price *</div>
                        <div class="col-md-7">
                          <input
                            type="text"
                            name="price"
                            onChange={inputHandleChange}
                            value={mortgageData.price}
                            class="form-control"
                            required
                          />
                          {errors.price && (
                            <p style={{ color: "red" }}>{errors.price}</p>
                          )}
                        </div>
                      </div>
                      <div
                        class="row"
                        style={{ marginTop: "10px", marginBottom: "10px" }}
                      >
                        <div class="col-md-5">Down Payment *</div>
                        <div class="col-md-7">
                          <input
                            type="text"
                            name="downpayment"
                            onChange={inputHandleChange}
                            value={mortgageData.downpayment}
                            class="form-control"
                            required
                          />
                          {errors.downpayment && (
                            <p style={{ color: "red" }}>{errors.downpayment}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="browse_img_head">
                        <h5>Results</h5>
                      </div>
                      <div
                        style={{
                          padding: "20px",
                          borderRadius: "10px",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                          backgroundColor: "#f9f9f9",
                          textAlign: "center",
                          minHeight: "120px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100px",
                            }}
                          >
                            <CircularProgress size={50} thickness={5} />
                          </div>
                        ) : (
                          <>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "15px",
                              }}
                            >
                              {/* Mortgage Principal */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "10px 0",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: "#333",
                                  }}
                                >
                                  Mortgage Principal:
                                </span>
                                <span
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#4CAF50",
                                  }}
                                >
                                  {mortgageResult.principal
                                    ? `$${mortgageResult.principal}`
                                    : "-"}
                                </span>
                              </div>

                              {/* Total Payment */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "10px 0",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: "#333",
                                  }}
                                >
                                  Total Payment:
                                </span>
                                <span
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#FF9800",
                                  }}
                                >
                                  {mortgageResult.totalpayment
                                    ? `$${mortgageResult.totalpayment}`
                                    : "-"}
                                </span>
                              </div>

                              {/* Monthly Payments */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "10px 0",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: "#333",
                                  }}
                                >
                                  Monthly Payments:
                                </span>
                                <span
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#3F51B5",
                                  }}
                                >
                                  {mortgageResult.monthlypayment
                                    ? `$${mortgageResult.monthlypayment}`
                                    : "-"}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <div>
                    <button
                      style={{ margin: "10px", width: "auto", height: "40px" }}
                      type="submit"
                      class="agentbtn"
                    >
                      Calculate
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      style={{ margin: "10px", width: "auto", height: "40px" }}
                      onClick={() => {
                        setMortgageData(initialMorgageData);
                        setMortgageResult({});
                      }}
                      class="agentbtn"
                    >
                      Reset
                    </button>
                  </div>
                </div>

                <p>* Required Fields</p>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={maxWidth}
        fullWidth={true}
        Transition
        Component={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        className="videoModal"
        open={openVideoModal}
      >
        <CancelIcon
          onClick={() => setOpenVideoModal(false)}
          style={{ float: "right", cursor: "pointer" }}
        />
        <DialogContent>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <video
              style={{ height: "500px" }}
              src={videoUrl.videurl}
              width="100%"
              autoPlay
              muted={videoUrl.video_music_type == 1 ? false : true}
              controls={videoUrl.video_music_type == 1 ? true : false}
            />
          </div>
        </DialogContent>
      </Dialog>
      <div class="walk-container">
        <Dialog
          maxWidth={largeWidth}
          fullWidth={true}
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={openWalkScore}
        >
          <DialogTitle id="customized-dialog-title">
            Walk Score
            <CancelIcon
              onClick={() => setOpenWalkScore(false)}
              style={{ float: "right", cursor: "pointer" }}
            />
          </DialogTitle>
          <DialogContent dividers style={{ overflow: "hidden" }}>
            <iframe
              title="walkScore"
              className="walkScore"
              src={`https://virtualtourcafe.com/admin/qwerty/${tourid}`}
              frameborder="0"
              style={{ width: "100%", height: "500px", border: "none" }}
            ></iframe>
          </DialogContent>
        </Dialog>
      </div>
      <Dialog
        maxWidth={maxWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openPanoromaModal}
        className="videoModal imgModal"
      >
        <CancelIcon
          onClick={() => setOpenPanoromaModal(false)}
          style={{ float: "right", cursor: "pointer" }}
        />
        <DialogContent>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "89vh",
            }}
          >
            <ReactPannellum
              id="1"
              sceneId="firstScene"
              imageSource={panoUrl}
              config={config}
            ></ReactPannellum>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={maxWidth}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openHouseModal}
      >
        <DialogTitle id="customized-dialog-title">
          Open House Announcements
          <CancelIcon
            onClick={() => setOpenHouseModal(false)}
            style={{ float: "right", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div class="popup-inner">
            <div class="box-wrap">
              <h4>Open House Announcement</h4>
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-xs-12">
                  {tourData.announcements.length > 0 &&
                    tourData.announcements.map((announcement) => (
                      <p>
                        {`${
                          announcement?.announcedate
                            ? new Date(announcement?.announcedate)
                                .toLocaleDateString()
                                .replace(/\//g, "-")
                            : ""
                        } ${announcement?.fromtime}${
                          announcement?.fromampm
                        } to ${announcement?.totime} ${announcement?.toampm}`}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
}

// =======================responsive navbar===============================
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // only execute all the code below in client side
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
// ===================--------------------end-----------==============
